import { ProjectMethodologyEnum } from 'gql/graphql';

import { useMemo } from 'react';

import { useBimExportWorkOrderChangeAnalyticsAsExcel } from './useBimExportWorkOrderChangeAnalyticsAsExcel';
import { useUerExportWorkOrderChangeAnalyticsAsExcel } from './useUerExportWorkOrderChangeAnalyticsAsExcel';

export const useExportWorkOrderChangeAnalyticsAsExcel = (
    workOrderChangeId: number,
    methodology: ProjectMethodologyEnum | undefined,
    onClose: () => void,
) => {
    const { bimExportWorkOrderChangeAnalyticsAsExcelStatus, bimExportWorkOrderChangeAnalyticsAsExcelMakeRequest } =
        useBimExportWorkOrderChangeAnalyticsAsExcel(workOrderChangeId, onClose);

    const { uerExportStatus, uerExportRequest } = useUerExportWorkOrderChangeAnalyticsAsExcel(
        workOrderChangeId,
        onClose,
    );

    return useMemo(() => {
        if (methodology === ProjectMethodologyEnum.Bim) {
            return {
                exportWorkOrderChangeAnalyticsAsExcelStatus: bimExportWorkOrderChangeAnalyticsAsExcelStatus,
                exportWorkOrderChangeAnalyticsAsExcelMakeRequest: bimExportWorkOrderChangeAnalyticsAsExcelMakeRequest,
            };
        }

        if (methodology === ProjectMethodologyEnum.Uer) {
            return {
                exportWorkOrderChangeAnalyticsAsExcelStatus: uerExportStatus,
                exportWorkOrderChangeAnalyticsAsExcelMakeRequest: uerExportRequest,
            };
        }

        return {};
    }, [
        bimExportWorkOrderChangeAnalyticsAsExcelMakeRequest,
        bimExportWorkOrderChangeAnalyticsAsExcelStatus,
        methodology,
        uerExportRequest,
        uerExportStatus,
    ]);
};
